module.exports = __webpack_public_path__ + "img/downarrow.3328d09a.svg";